export default __webpack_public_path__ + "images/9ec6b87ee2a967c482db6ceeb56ed9da.png";